import ReactDOM from 'react-dom';
const liveColumnControlHosts = new Set();
const unmountHost = (host) => {
    try {
        ReactDOM.unmountComponentAtNode(host);
    }
    catch (e) {
    }
    host.remove();
    liveColumnControlHosts.delete(host);
};
export const registerColumnControlHost = (host) => {
    liveColumnControlHosts.add(host);
};
export const sweepColumnControlHosts = (container) => {
    liveColumnControlHosts.forEach(host => {
        if (!host.isConnected || (container && container.contains(host))) {
            unmountHost(host);
        }
    });
};
//# sourceMappingURL=column-control-roots.js.map